<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Transferencia</p>
              <div class="ms-auto">
                <argon-button v-if="form.status === 'pending'" color="success"
                  size="sm" @click="save" style="margin-right: 10px;">Guardar</argon-button>
                <argon-button v-if="form.id != 0 && form.status === 'pending'" color="success"
                  size="sm" @click="completeTransfer">Completar</argon-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">

              <div class="col-md-6">
                <label for="transfer-date" class="form-control-label">Fecha de Transferencia</label>
                <input
                  id="transfer-date"
                  type="date"
                  class="form-control"
                  v-model="form.transfer_date"
                  :disabled="form.status !== 'pending'"
                  @change="loadSoldProducts"
                />
              </div>

              <div class="col-md-6">
                <label for="status-select" class="form-control-label">Estado</label>
                <select id="status-select" class="form-control" v-model="form.status" :disabled="form.status === 'completed'">
                  <option value="pending">Pendiente</option>
                  <option value="completed">Completado</option>
                  <option value="cancelled">Cancelado</option>
                </select>
              </div>

              <div class="col-md-12">
                <label for="notes-input" class="form-control-label">Observaciones</label>
                <ArgonTextarea type="text" v-model="form.notes" :disabled="form.status === 'completed'" />
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12" v-if="form.id !== 0">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Productos vendidos del día</p>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Producto</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Cantidad Vendida
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Inventario Actual
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Traslado 1ra a 2da
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Traslado 2da a 3ra
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Averías
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Averías Módulo
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Consumo
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Inventario Final
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="value in data.data" :key="value.id || value.inventory_id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="">
                            <h6 class="mb-0 text-sm">{{ value?.inventory?.name ?? 'No encontrado' }}</h6>
                            <span class="badge badge-sm bg-gradient-success">
                              Ref: {{ value?.inventory?.ref ?? 'N/A' }}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-sm font-weight-bold">{{ value.sold_stock || value.total_sold || 0 }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-sm font-weight-bold">{{ value.current_stock || 0 }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <input type="number"
                          v-model.number="value.transfer_first_to_second"
                          class="form-control form-control-sm text-center"
                          min="0" 
                          step="0.01"
                          @blur="calculateFinalInventory(value); updateDetail(value)"
                          :disabled="form.status !== 'pending'"/>
                      </td>
                      <td class="align-middle text-center">
                        <input type="number"
                          v-model.number="value.transfer_second_to_third"
                          class="form-control form-control-sm text-center"
                          min="0" 
                          step="0.01"
                          @blur="calculateFinalInventory(value); updateDetail(value)"
                          :disabled="form.status !== 'pending'"/>
                      </td>
                      <td class="align-middle text-center">
                        <input type="number"
                          v-model.number="value.damages"
                          class="form-control form-control-sm text-center"
                          min="0" 
                          step="0.01"
                          @blur="calculateFinalInventory(value); updateDetail(value)"
                          :disabled="form.status !== 'pending'"/>
                      </td>
                      <td class="align-middle text-center">
                        <input type="number"
                          v-model.number="value.module_damage"
                          class="form-control form-control-sm text-center"
                          min="0" 
                          step="0.01"
                          @blur="calculateFinalInventory(value); updateDetail(value)"
                          :disabled="form.status !== 'pending'"/>
                      </td>
                      <td class="align-middle text-center">
                        <input type="number"
                          v-model.number="value.consumption"
                          class="form-control form-control-sm text-center"
                          min="0" 
                          step="0.01"
                          @blur="calculateFinalInventory(value); updateDetail(value)"
                          :disabled="form.status !== 'pending'"/>
                      </td>
                      <td class="align-middle text-center">
                        <input type="number"
                          v-model.number="value.final_inventory"
                          class="form-control form-control-sm text-center"
                          min="0" 
                          step="0.01"
                          readonly
                          :disabled="true"/>
                      </td>
                    </tr>
                    <tr v-if="data.data.length === 0">
                      <td colspan="9" class="text-center py-4">
                        <p class="text-muted mb-0">No hay productos vendidos para esta fecha. Seleccione una fecha diferente.</p>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import service from "../../../services/productionTransfers.service";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Transfers Create",
  data() {
    return {
      showMenu: false,
      form: {
        id: 0,
        transfer_date: new Date().toISOString().split('T')[0],
        status: 'pending',
        notes: '',
      },
      data: {
        data: []
      },
      bodegas: [],
    };
  },
  components: { ArgonButton, ArgonTextarea },
  methods: {
    async loadSoldProducts() {
      if (!this.form.transfer_date) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe seleccionar una fecha primero.',
        });
        return;
      }

      try {
        const response = await service.getSoldProductsByDate(this.form.transfer_date);
        const productsSold = response.data || [];

        // Mapear los productos vendidos agrupados por inventory_id a la estructura de detalles
        this.data.data = productsSold.map(product => {
          // Buscar si ya existe un detalle para este producto (en caso de edición)
          const existingDetail = this.data.data.find(d => d.inventory_id === product.inventory_id);
          
          // Calcular total de averías de todos los remission_details agrupados
          const totalAverias = product.remission_details?.reduce((sum, detail) => {
            return sum + (parseFloat(detail.averia) || 0);
          }, 0) || product.total_damages || 0;
          
          return {
            id: existingDetail?.id || null,
            inventory_id: product.inventory_id,
            inventory: product.inventory,
            sold_stock: product.total_sold || 0,
            total_sold: product.total_sold || 0,
            total_obsequios: product.total_obsequios || 0,
            transfer_first_to_second: existingDetail?.transfer_first_to_second || 0,
            transfer_second_to_third: existingDetail?.transfer_second_to_third || 0,
            damages: existingDetail?.damages || totalAverias || 0,
            current_stock: product.current_stock !== undefined ? product.current_stock : (existingDetail?.current_stock || 0),
            consumption: existingDetail?.consumption || 0,
            module_damage: existingDetail?.module_damage || 0,
            final_inventory: 0, // Se calculará automáticamente
            // Guardar los detalles de remisiones para referencia
            remission_details: product.remission_details || [],
          };
        });

        // Calcular el inventario final para cada producto
        this.data.data.forEach(item => {
          this.calculateFinalInventory(item);
        });

        if (productsSold.length === 0) {
          await Swal.fire({
            icon: 'info',
            title: 'Sin productos',
            text: 'No se encontraron productos vendidos para esta fecha.',
          });
        }
      } catch (error) {
        console.error("Error al cargar productos vendidos:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al cargar los productos vendidos',
        });
      }
    },
    async getData() {
      if (this.form.id) {
        const response = await this.$store.dispatch('productionTransfers/getData', this.form.id);
        if (response && response.details) {
          // Normalizar los detalles para asegurar que todos los campos estén presentes
          this.data.data = response.details.map(detail => ({
            id: detail.id || null,
            inventory_id: detail.inventory_id || null,
            inventory: detail.inventory || null,
            sold_stock: detail.sold_stock !== undefined && detail.sold_stock !== null ? parseFloat(detail.sold_stock) : 0,
            total_sold: detail.sold_stock !== undefined && detail.sold_stock !== null ? parseFloat(detail.sold_stock) : 0,
            transfer_first_to_second: detail.transfer_first_to_second !== undefined && detail.transfer_first_to_second !== null ? parseFloat(detail.transfer_first_to_second) : 0,
            transfer_second_to_third: detail.transfer_second_to_third !== undefined && detail.transfer_second_to_third !== null ? parseFloat(detail.transfer_second_to_third) : 0,
            damages: detail.damages !== undefined && detail.damages !== null ? parseFloat(detail.damages) : 0,
            current_stock: detail.current_stock !== undefined && detail.current_stock !== null ? parseFloat(detail.current_stock) : 0,
            consumption: detail.consumption !== undefined && detail.consumption !== null ? parseFloat(detail.consumption) : 0,
            module_damage: detail.module_damage !== undefined && detail.module_damage !== null ? parseFloat(detail.module_damage) : 0,
            final_inventory: 0, // Se calculará automáticamente
          }));

          // Calcular el inventario final para cada producto
          this.data.data.forEach(item => {
            this.calculateFinalInventory(item);
          });
        } else {
          this.data.data = [];
        }
      }
    },
    calculateFinalInventory(detail) {
      // Inventario Final = Inventario Actual - Averías - Averías Módulo - Consumos
      const currentStock = parseFloat(detail.current_stock || 0);
      const damages = parseFloat(detail.damages || 0);
      const moduleDamage = parseFloat(detail.module_damage || 0);
      const consumption = parseFloat(detail.consumption || 0);
      
      const finalInventory = currentStock - damages - moduleDamage - consumption;
      
      // Asegurar que no sea negativo
      detail.final_inventory = Math.max(0, finalInventory);
    },
    async save(silent = false) {
      try {
        // Si es una nueva transferencia (id === 0), guardar solo el header sin detalles
        // Los detalles se guardarán por separado después
        let transferData;
        
        if (this.form.id === 0) {
          // Crear solo el header sin detalles
          transferData = {
            ...this.form,
            // No incluir details al crear por primera vez
          };
        } else {
          // Si ya existe, preparar los detalles si existen
          const validDetails = this.data.data.filter(detail => detail.inventory_id);
          
          transferData = {
            ...this.form,
            details: validDetails.length > 0 ? validDetails.map(detail => {
              // Asegurar que todos los campos estén presentes con valores por defecto
              const detailData = {
                inventory_id: detail.inventory_id ? parseInt(detail.inventory_id) : null,
                current_stock: detail.current_stock !== undefined && detail.current_stock !== null ? parseFloat(detail.current_stock) : 0,
                sold_stock: detail.sold_stock !== undefined && detail.sold_stock !== null ? parseFloat(detail.sold_stock || detail.total_sold) : 0,
                transfer_first_to_second: detail.transfer_first_to_second !== undefined && detail.transfer_first_to_second !== null ? parseFloat(detail.transfer_first_to_second) : 0,
                transfer_second_to_third: detail.transfer_second_to_third !== undefined && detail.transfer_second_to_third !== null ? parseFloat(detail.transfer_second_to_third) : 0,
                damages: detail.damages !== undefined && detail.damages !== null ? parseFloat(detail.damages) : 0,
                consumption: detail.consumption !== undefined && detail.consumption !== null ? parseFloat(detail.consumption) : 0,
                module_damage: detail.module_damage !== undefined && detail.module_damage !== null ? parseFloat(detail.module_damage) : 0,
                final_inventory: detail.final_inventory !== undefined && detail.final_inventory !== null ? parseFloat(detail.final_inventory) : 0,
              };
              
              // Validar que no haya NaN
              Object.keys(detailData).forEach(key => {
                if (typeof detailData[key] === 'number' && isNaN(detailData[key])) {
                  detailData[key] = 0;
                }
              });
              
              return detailData;
            }) : []
          };
        }

        const response = await this.$store.dispatch("productionTransfers/save", transferData);
        
        if (response && response.status >= 200 && response.status < 300) {
          const previousId = this.form.id;
          this.form.id = response.data.id || 0;
          
          // Si no es una llamada silenciosa, mostrar mensaje de éxito
          if (!silent) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
            });
          }
          
          // Si es la primera vez que se guarda (antes no tenía ID), cargar los productos vendidos
          if (previousId === 0 && this.form.id !== 0) {
            await this.loadSoldProducts();
          } else if (this.form.id !== 0) {
            // Si ya tenía ID, recargar los datos para obtener los IDs reales de los detalles
            await this.getData();
          }
        } else {
          throw new Error(response.data?.message || 'Error al guardar la transferencia');
        }
      } catch (error) {
        console.error("Error al guardar la transferencia:", error);
        if (!silent) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || error.message || 'Error al guardar la transferencia',
          });
        }
      }
    },
    async completeTransfer() {
      try {
        const confirmResult = await Swal.fire({
          icon: 'warning',
          title: 'Confirmar Completar',
          text: 'Al completar la transferencia no se podrá editar.',
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          backdrop: true,
        });
        
        if (!confirmResult.isConfirmed) {
          return;
        }
        
        this.form.status = 'completed';
        await this.save();
      } catch (error) {
        console.error("Error al completar la transferencia:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al completar la transferencia',
        });
      }
    },
    async updateDetail(detail) {
      if (this.form.status !== 'pending') {
        return;
      }

      // Validar que tenga inventory_id
      if (!detail.inventory_id) {
        return;
      }

      // Si la transferencia no está guardada, guardarla primero (silenciosamente)
      if (!this.form.id || this.form.id === 0) {
        await this.save(true);
        // Si después de guardar aún no hay ID, no continuar
        if (!this.form.id || this.form.id === 0) {
          return;
        }
      }

      try {
        // Asegurar que el inventario final esté calculado antes de guardar
        this.calculateFinalInventory(detail);

        const detailData = {
          inventory_id: detail.inventory_id,
          transfer_first_to_second: detail.transfer_first_to_second !== undefined && detail.transfer_first_to_second !== null ? parseFloat(detail.transfer_first_to_second) : 0,
          transfer_second_to_third: detail.transfer_second_to_third !== undefined && detail.transfer_second_to_third !== null ? parseFloat(detail.transfer_second_to_third) : 0,
          damages: detail.damages !== undefined && detail.damages !== null ? parseFloat(detail.damages) : 0,
          consumption: detail.consumption !== undefined && detail.consumption !== null ? parseFloat(detail.consumption) : 0,
          module_damage: detail.module_damage !== undefined && detail.module_damage !== null ? parseFloat(detail.module_damage) : 0,
          final_inventory: detail.final_inventory !== undefined && detail.final_inventory !== null ? parseFloat(detail.final_inventory) : 0,
          current_stock: detail.current_stock !== undefined && detail.current_stock !== null ? parseFloat(detail.current_stock) : 0,
          sold_stock: detail.sold_stock !== undefined && detail.sold_stock !== null ? parseFloat(detail.sold_stock || detail.total_sold) : 0,
        };

        // Validar que no haya NaN
        Object.keys(detailData).forEach(key => {
          if (typeof detailData[key] === 'number' && isNaN(detailData[key])) {
            detailData[key] = 0;
          }
        });

        // Usar 'new' si el detalle no tiene ID, o el ID real si existe
        const currentDetailId = detail.id;
        const detailId = currentDetailId || 'new';
        const response = await service.updateDetail(this.form.id, detailId, detailData);
        
        // Si el detalle no tenía ID y se creó, actualizar el ID en el objeto local
        // Buscar el objeto en el array para evitar condiciones de carrera
        if (!currentDetailId && response.data && response.data.id) {
          const detailToUpdate = this.data.data.find(d => d.inventory_id === detail.inventory_id);
          if (detailToUpdate) {
            detailToUpdate.id = response.data.id;
          }
        }
      } catch (error) {
        console.error("Error al actualizar el detalle:", error);
        // No mostrar error al usuario, solo loguear
      }
    },
    async getBodegas() {
      try {
        this.bodegas = await this.$store.dispatch('bodegas/getAll');
      } catch (error) {
        console.error('Error al obtener bodegas:', error);
      }
    },
  },
  async mounted() {
    const route = useRoute();
    const dataEdit = route.params.data;

    if (dataEdit) {
      try {
        const params = JSON.parse(dataEdit);
        if (params && params.id) {
          this.form.id = params.id || 0;
          this.form.transfer_date = params.transfer_date || new Date().toISOString().split('T')[0];
          this.form.status = params.status || 'pending';
          this.form.notes = params.notes || '';
          
          await this.getData();
        }
      } catch (error) {
        console.error("Error al parsear los datos del registro:", error);
      }
    } else {
      // Si es un registro nuevo, no cargar productos hasta que se guarde
      // await this.loadSoldProducts();
    }
    
    await this.getBodegas();
    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  cursor: not-allowed;
}
</style>

